
import { Component, Watch } from 'vue-property-decorator'
import moment from 'moment'
import ViewModel from '@/models/ViewModel'
import Widget from '@/components/Widget/Widget.vue'
import WebMessage from '@/models/WebMessage'
import PublisherReconciliation, {
  PublisherReconciliationInvoice,
  PublisherReconciliationRow,
  PublisherReconciliationUnmatchedRow,
} from '@/models/PublisherReconciliation'
import FooterNav from '@/components/FooterNav/FooterNav.vue'
import IconAction from '@/components/IconAction/IconAction.vue'
import row_fields from './fields/rows-fields'
import PublisherReconciliationRowsView from './components/PublisherReconciliationRowsView.vue'
import PublisherReconciliationInvoicesView from './components/PublisherReconciliationInvoicesView.vue'
import PublisherReconciliationUnmatched from './components/PublisherReconciliationUnmatched.vue'

@Component({
  components: {
    Widget,
    FooterNav,
    IconAction,
    PublisherReconciliationRowsView,
    PublisherReconciliationInvoicesView,
    PublisherReconciliationUnmatched,
  },
})
class PublisherReconciliationView extends ViewModel {
  public activeTab: number = 0

  public loading: boolean = false

  public reconciliation_rows: PublisherReconciliationRow[] = []

  public unmatched_rows: PublisherReconciliationUnmatchedRow[] = []

  public uploaded_invoices: PublisherReconciliationInvoice[] = []

  public ready: boolean = false

  public tabList = ['rows', 'invoices', 'unmatched']

  @Watch('activeTab', { immediate: true })
  public onActiveTabChange(newValue: number) {
    if (!this.ready) return
    this.$router.replace({
      query: {
        ...this.$route.query,
        view: this.tabList[newValue],
      },
    })
  }

  // watch route query change/ if this.tabList[newValue] !== route querr.view then change activetab to route query view
  @Watch('$route.query.view', { immediate: true })
  public onRouteQueryChange(newValue: string) {
    const tabIndex = this.tabList.indexOf(newValue)
    if (tabIndex !== -1 && tabIndex !== this.activeTab) {
      this.activeTab = tabIndex
    }
    if (newValue !== 'invoices' && this.$route.query.reference) {
      this.$router.replace({
        query: {
          ...this.$route.query,
          reference: undefined,
        },
      })
    }
  }

  public get billing_month(): string {
    return this.$route.params.month
  }

  public get pageTitle(): string {
    return `Publisher Reconciliation - ${this.formatBillingMonth(this.billing_month)}`
  }

  public formatBillingMonth(value: string): string {
    if (!value) {
      return ''
    }

    return moment(value).format('MMMM YYYY')
  }

  public async mounted(): Promise<void> {
    if (this.$route.hash) {
      const tabIndex = this.tabList.indexOf(this.$route.hash.replace('#', ''))

      if (tabIndex !== -1) {
        this.activeTab = tabIndex
      }
    }

    this.ready = true
  }
}

export default PublisherReconciliationView
